  <div [class]="themeClass">
    <router-outlet></router-outlet>
  </div>

